// Anemoia cart flourish (custom).
//
// The add-to-cart sun-aura: a brief spinning glow burst, themed per mode
// (solar gold / lunar neon-green via CSS), triggered when a product is added
// to cart. Wires to Horizon 3.5.1's real cart event (brief sec.2.1): the
// theme dispatches `cart:update` on document for both adds and updates, so we
// fire only on a genuine, successful add from the product form
// (detail.data.source === 'product-form-component', !detail.data.didError).
//
// Decorative and inert; under reduced motion the CSS collapses it to a quick
// fade with no spin.

const CART_EVENT = 'cart:update';
const ADD_SOURCES = ['product-form-component'];

class AnemoiaCartFlourish extends HTMLElement {
  connectedCallback() {
    this.onCart = (event) => {
      const data = (event.detail && event.detail.data) || {};
      if (data.didError) return;
      if (!ADD_SOURCES.includes(data.source)) return;
      this.burst();
    };
    document.addEventListener(CART_EVENT, this.onCart);
  }

  disconnectedCallback() {
    document.removeEventListener(CART_EVENT, this.onCart);
    clearTimeout(this.timer);
  }

  burst() {
    // Restart the CSS animation even if it's mid-flight.
    this.classList.remove('is-active');
    void this.offsetWidth; // force reflow so the class re-add re-triggers
    this.classList.add('is-active');
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.classList.remove('is-active'), 1100);
  }
}

if (!customElements.get('anemoia-cart-flourish')) {
  customElements.define('anemoia-cart-flourish', AnemoiaCartFlourish);
}
